import { UserLangCode } from "src/utils/util.types";
import { SlotStatisticsTypes, StatisticsType } from "../types/statistics.entity";
import { BaseStatAggregator } from "./base/base-stat-aggregator";
import { Timestamp } from "firebase/firestore";
import { DateUtils } from "src/utils/date.util";
import { slotRepository } from "src/features/slots/slot.repository";

export class SlotStatsAggregator extends BaseStatAggregator {
  protected execQuery(statType: SlotStatisticsTypes, langCode?: UserLangCode): Promise<number> {
    if (statType == "LAST_MONTH_SLOTS")
      return slotRepository.count({
        createdAt: {
          $gte: Timestamp.fromDate(DateUtils.subtract(new Date(), 30, "day").toJSDate()),
        },
        langCode,
      });
    else if (statType == "AVAILABLE_SLOTS")
      return slotRepository.count({
        status: "AVAILABLE",
        langCode,
      });
    else if (statType == "BOOKED_SLOTS")
      return slotRepository.count({
        status: "BOOKED",
        langCode,
      });
    else return slotRepository.count({ langCode });
  }
}
